<template>
  <div>
    <el-form
      class="form"
      size="small"
      label-position="right"
      label-width="160px"
      :rules="rules"
      :model="examForm"
      ref="examForm"
    >
      <el-row>
        <el-col>
          <el-form-item label="考试类型：" required>
            <el-radio-group
              v-if="!edit"
              v-model="examForm.examType"
              @change="examTypeChange"
              :disabled="isFromDetail"
            >
              <el-radio
                v-for="item in examTypeData"
                :key="item.paramKey"
                :label="item.paramKey"
                >{{ item.paramValue }}</el-radio
              >
            </el-radio-group>
            <el-radio
              v-else
              :label="examForm.examType"
              :value="examForm.examType"
              >{{ examForm.examTypeName }}</el-radio
            >
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item label="试卷名称：" prop="paperId" required>
            <load-select
              v-if="!edit"
              class="form-select"
              v-model="examForm.paperId"
              dictLabel="paperName"
              dictValue="uuid"
              :data="idata"
              :page="ipage"
              :hasMore="imore"
              :request="getiData"
              @ChangeValue="paperChanged"
              placeholder="请选择试卷（输入试卷名称关键字以查询）"
            />
            <el-input
              v-else
              :value="`${examForm.paperName}(${examForm.totalScore}分)`"
              disabled
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="考试说明：" prop="examDesc" required>
            <el-input maxlength="200" show-word-limit :disabled="isFromDetail" type="textarea" placeholder="请输入考试说明" v-model="examForm.examDesc"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12"
          ><el-form-item label="及格分数：" prop="passScore" required>
            <el-input-number
              v-model="examForm.passScore"
              :min="0"
              :max="totalScore"
              :disabled="isFromDetail"
            ></el-input-number>
          </el-form-item>
        </el-col>
        <!--<el-col :span="12"
          ><el-form-item label="考试学分：" prop="examCredit" required>
            <el-input-number
              v-model="examForm.examCredit"
              :min="0"
              :max="10"
              :step="0.1"
              :disabled="isFromDetail"
            ></el-input-number>
          </el-form-item>
        </el-col>-->
      </el-row>
      <el-row>
        <el-col :span="24" v-for="(item, i) in examForm.examCreditList" :key="i+'examCreditList'">
          <el-form-item :label="`分数段${i+1}：`" :prop="'examCreditList.' + i + '.examStartScore'" :rules="[
              { required: true, message: '请输入分数段和可获得学时', trigger: 'blur' }
            ]">
            <el-input :disabled="isFromDetail" style="width: 20%" placeholder="请输入分数段" onkeyup="value=value.replace(/^\.+|[^\d.]/g,'')" v-model="examForm.examCreditList[i].examStartScore" @change="changeScore(i)"></el-input><span>&nbsp;及以上，可获得学时：</span>
            <el-input :disabled="isFromDetail" style="width: 20%" placeholder="请输入可获得学时" onkeyup="value=value.replace(/^\.+|[^\d.]/g,'')" v-model="examForm.examCreditList[i].examCredit" @change="changeCredit(i)"></el-input>
            <el-button :disabled="isFromDetail" icon="el-icon-plus" type="primary" class="m-l-12" @click="addExamCredit" v-if="i == Number(examForm.examCreditList.length - 1)"> 添加分数段</el-button>
            <el-button :disabled="isFromDetail" class="m-l-12" @click="removeItem(i)" v-if="i > 0">删除</el-button>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="限制时长：" prop="isLimitDuration" required>
            <el-radio-group
              v-model="examForm.isLimitDuration"
              @change="changeIsLimitDuration"
              :disabled="isFromDetail"
            >
              <el-radio
                v-for="item in publicData"
                :key="item.paramKey"
                :label="item.paramKey"
                >{{ item.paramValue }}
              </el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="12"
          ><el-form-item
            label="考试时限："
            prop="limitDuration"
            :required="examForm.isLimitDuration == 1"
          >
            <el-input-number
              style="width: 90%"
              v-model="examForm.limitDuration"
              :min="1"
              :max="360"
              :disabled="examForm.isLimitDuration == 0 || isFromDetail"
            ></el-input-number>
            <span class="m-l-12">分钟</span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12"
          ><el-form-item label="限制时间：" prop="isLimitTime" required>
            <el-radio-group
              v-model="examForm.isLimitTime"
              @change="changeIsLimitTime"
              :disabled="isFromDetail"
            >
              <el-radio
                v-for="item in publicData"
                :key="item.paramKey"
                :label="item.paramKey"
                >{{ item.paramValue }}</el-radio
              >
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="12"
          ><el-form-item
            label="考试时间："
            prop="examTime"
            :rules="[
                {
                  required: examForm.isLimitTime == 1,
                  validator: checkExamTime,
                  trigger: 'blur',
                },
              ]"
          >
            <el-date-picker
              unlink-panels
              v-model="examForm.examTime"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              format="yyyy-MM-dd HH:mm"
              :disabled="examForm.isLimitTime == 0 || isFromDetail"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12"
          ><el-form-item label="限制次数：" prop="isLimitNum" required>
            <el-radio-group
              v-model="examForm.isLimitNum"
              @change="changeIsLimitNum"
              :disabled="isFromDetail"
            >
              <el-radio
                v-for="item in publicData"
                :key="item.paramKey"
                :label="item.paramKey"
                >{{ item.paramValue }}</el-radio
              >
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="12"
          ><el-form-item
            label="考试次数："
            prop="limitNum"
            :rules="[
                {
                  required: examForm.isLimitNum == 1,
                  message: '请输入考试次数',
                  trigger: 'blur',
                },
              ]"
          >
            <el-input-number
              v-model="examForm.limitNum"
              :min="1"
              :max="100"
              :disabled="examForm.isLimitNum == 0 || isFromDetail"
            ></el-input-number>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col
          ><el-form-item
            label="可以补考："
            prop="isCanRepexam"
            :required="examForm.isLimitNum == 1"
          >
            <el-radio-group
              v-model="examForm.isCanRepexam"
              :disabled="examForm.isLimitNum == 0 || isFromDetail"
              @change="changeIsCanRepexam"
            >
              <el-radio
                v-for="item in publicData"
                :key="item.paramKey"
                :label="item.paramKey"
                >{{ item.paramValue }}</el-radio
              >
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item
            label="补考次数："
            prop="reexamNum"
            :rules="[{ required: examForm.isCanRepexam == 1, message: '请输入补考次数' }]"
          >
            <el-input-number
              v-model="examForm.reexamNum"
              :min="1"
              :max="100"
              :disabled="examForm.isCanRepexam == 0 || isFromDetail"
            ></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label="补考时间："
            prop="reexamTime"
            :rules="[
                {
                  required: examForm.examTime && examForm.examTime.length > 0 && examForm.isCanRepexam == 1 && examForm.isLimitTime == 1,
                  validator: checkReexamTime,
                  trigger: 'blur',
                },
              ]"
          >
            <el-date-picker
              unlink-panels
              v-model="examForm.reexamTime"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              format="yyyy-MM-dd HH:mm"
              :picker-options="reexamOptions"
              :disabled="examForm.isCanRepexam == 0 || examForm.isLimitTime == 0 || isFromDetail"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <!--定向学员选择-->
    <DirectMemberSelect
      @addSucceed="addSucceed"
      :defaultCheckedKeys="[]"
      :examId="examId"
      :showDirectMemberSelect="showDirectMemberSelect"
      v-if="showDirectMemberSelect.flag"
      @closeManage="closeDirectManage"
    />
  </div>
</template>

<script>
import { editExamInfo, saveExamInfo } from "@/api/examInfo";
import { getPublishedPaperList } from "@/api/examPaper";
import { Confirm } from "@/components/Confirm";
import LoadSelect from "@/components/load-select/index.vue";
import { setItem } from "@/utils/storage.js";
import DirectMemberSelect from "@/views/examInfo/members/directExamMemS.vue";
import moment from "moment";
export default {
  components: {
    LoadSelect,
    DirectMemberSelect
  },
  props: {
    examTypeData: {
      type: Array,
      default: () => [],
    },
    publicData: {
      type: Array,
      default: () => [],
    },
    edit: { type: Boolean, default: false },
    isFromDetail: {
      type:  Boolean,
      default: false
    }
  },
  data() {
    let that = this;
    return {
      examId: "",
      showDirectMemberSelect: { flag: false },
      deptTreeData: [],
      ipage: 1,
      imore: true,
      idata: [],
      examForm: {
        examType: 2,
        paperId: "",
        passScore: 80,
        examCredit: 0,
        isLimitDuration: 0,
        isLimitTime: 0,
        isLimitNum: 0,
        limitDuration: 1,
        limitNum: 1,
        examTime: [],
        isCanRepexam: 0,
        reexamNum: 1,
        reexamTime: [],
        examDesc: "",
        examCreditList: [{
          examStartScore: '',
          examCredit: ''
        }],
      },
      rules: {
        examDesc: [{ required: true, message: "请输入考试说明" }],
        paperId: [
          {
            required: true,
            message: "请选择试卷",
            trigger: "blur, change",
          },
        ],

      },
      paperData: [],
      totalScore: 100,
      reexamOptions: {
        disabledDate(date) {
          return moment(that.examForm.examTime[1]) > date.getTime();
        },
      },
    };
  },
  methods: {

    // 考试时间校验
    checkExamTime(rule, value, callback) {
      if (this.examForm.isLimitTime == 0) {
        callback();
      } else {
        if (value && value.length === 0 || !value) {
          callback(new Error("请选择考试时间"));
        } else if(moment(value[0]).valueOf() == moment(value[1]).valueOf()) {
          callback(new Error("开始时间不能和结束时间相等"));
        } else {
          callback();
        }
      }
    },
    // 补考时间校验
    checkReexamTime(rule, value, callback) {
      if (this.examForm.isCanRepexam == 0 || this.examForm.isLimitTime == 0) {
        callback();
      } else {
        if (value && value.length === 0 || !value) {
          callback(new Error("请选择补考时间"));
        } else if (
          moment(value[0]) <= moment(this.examForm.examTime[1])
        ) {
          callback(new Error("补考时间不能早于考试时间"));
        } else if(moment(value[0]).valueOf() == moment(value[1]).valueOf()) {
          callback(new Error("开始时间不能和结束时间相等"));
        } else {
          callback();
        }
      }
    },

    getiData({ page = 1, more = false, keyword = "" } = {}) {
      return new Promise((resolve) => {
        getPublishedPaperList({ page, name: keyword, publishStatus: 1 }).then(
          ({ code, data }) => {
            if (code !== 0) return;
            if (more) {
              this.idata = [...this.idata, ...data.records];
            } else {
              this.idata = data.records;
            }
            this.ipage = data.current;
            let { current, total, size } = data;
            this.imore = current * size < total;
            this.ipage = current;
            resolve();
          }
        );
      });
    },
    // 分数校验
    changeScore(index) {
      let value = this.examForm.examCreditList[index].examStartScore;
      if (parseFloat(value) <= 0) {
        this.$message({
          message: "分数必须大于0，请重新输入",
          type: "error",
        });
        this.examForm.examCreditList[index].examStartScore = '';
        return;
      }
      if (value.length > 0) {
        if (value.indexOf('.')>0){
          value = value.slice(0,value.indexOf('.')+2);
          this.examForm.examCreditList[index].examStartScore = value;
        }
        this.examForm.examCreditList.forEach((ele, i) => {
          if (index !== i && parseFloat(ele.examStartScore) == parseFloat(value)) {
            this.$message({
              message: "该分数段已存在，请重新输入",
              type: "error",
            });
            this.examForm.examCreditList[index].examStartScore = "";
            return;
          }
        })
      }
    },
    // 学分校验
    changeCredit(index) {
      let value = this.examForm.examCreditList[index].examCredit;
      let examStartScore = this.examForm.examCreditList[index].examStartScore;
      if (parseFloat(value) <= 0) {
        this.$message({
          message: "学时必须大于0，请重新输入",
          type: "error",
        });
        this.examForm.examCreditList[index].examCredit = '';
        return;
      }
      if (parseFloat(value) > 5) {
        this.$message({
          message: "最多可设置5学时，请重新输入",
          type: "error",
        });
        this.examForm.examCreditList[index].examCredit = '';
        return;
      }
      if(value.indexOf('.')>0){
        this.examForm.examCreditList[index].examCredit = value.slice(0,value.indexOf('.')+3)
      }
      let flag = true;
      this.examForm.examCreditList.forEach((ele, i) => {
        if (index !== i && ele.examCredit && 
        (parseFloat(examStartScore) > parseFloat(ele.examStartScore) && parseFloat(value) <= parseFloat(ele.examCredit) || (parseFloat(examStartScore) < parseFloat(ele.examStartScore) && parseFloat(value) >= parseFloat(ele.examCredit)))) {
          flag = false;
          this.examForm.examCreditList[index].examCredit = "";
          return;
        }
      })
      if (!flag) {
        this.$message({
          message: "该分数段输入学分有误！",
          type: "error",
        });
      }
    },
    removeItem(index) {
      this.examForm.examCreditList.splice(index, 1); 
    },
    addExamCredit() {
      // 增加最多只能添加20期的校验
      if (this.examForm.examCreditList.length > 20) {
        this.$message.warning("最多只能添加20个分数段");
        return;
      }
      // 处理tagList和ChildList
      this.examForm.examCreditList.push({
        examStartScore: '',
        examCredit: ''
      });
    },
    // 考试类型改变
    examTypeChange(val) {
      this.$emit("changeExamType", val);
    },

    //是否限制时长
    changeIsLimitDuration(e) {
      if (e == 0) {
        this.examForm.limitDuration = 1;
      }
    },
    //是否限制时间
    changeIsLimitTime(e) {
      if (e == 0) {
        this.examForm.examTime = [];
        this.examForm.reexamTime = [];
      }
    },
    //是否补考改变
    changeIsCanRepexam(e) {
      if (e == 0) {
        this.examForm.reexamNum = 1;
        this.examForm.reexamTime = [];
      }
    },

    //是否限制次数改变
    changeIsLimitNum(e) {
      if (e == 0) {
        this.examForm.limitNum = 1;
        //补考重置
        if (this.examForm.isCanRepexam == 1) {
          this.examForm.isCanRepexam = 0;
          this.examForm.reexamNum = 1;
          this.examForm.reexamTime = [];
        }
      }
    },

    // 根据名称搜索试卷
    searchPaper(query) {
      getPublishedPaperList({ name: query }).then((res) => {
        if (!res || res.code != 0) return;
        this.paperData = res.data;
      });
    },
    // 选择的试卷改变
    paperChanged(val) {
      let uuid = val;
      this.idata.forEach((ele) => {
        if (ele.uuid == uuid) {
          this.totalScore = ele.totalScore;
          this.examForm.passScore = (ele.totalScore * 0.8).toFixed(1);
          this.examForm.paperId = uuid;
          return;
        }
      });
    },
    // 重置
    reset() {
      if (this.edit) {
        Object.assign(this.examForm, {
          passScore: 80,
          examCredit: 0,
          isLimitDuration: 0,
          isLimitTime: 0,
          isLimitNum: 0,
          limitDuration: 1,
          limitNum: 1,
          examTime: [],
        });
      } else {
        this.$refs["examForm"].resetFields();
      }
    },
    submit(val) {
      let flag = true;
      this.$refs["examForm"].validate((res) => {
        this.examForm.examCreditList.forEach(ele => {
          if (ele.examCredit.length <= 0) {
            flag = false;
            return;
          }
        });
        if (!flag) {
          this.$message({
            message: "可获得学时不能为空",
            type: "error",
          });
          return;
        }
        if (res && flag) {
          let params = {
            examType: this.examForm.examType,
            passScore: this.examForm.passScore,
            examCredit: this.examForm.examCredit,
            isLimitDuration: this.examForm.isLimitDuration,
            isLimitTime: this.examForm.isLimitTime,
            isLimitNum: this.examForm.isLimitNum,
            isCanRepexam: this.examForm.isCanRepexam,
            examCreditList: this.examForm.examCreditList,
            examDesc: this.examForm.examDesc,
          };
          if (this.examForm.isLimitDuration) {
            params["limitDuration"] = this.examForm.limitDuration;
          }
          if (this.examForm.isLimitTime) {
            params["limitStartTime"] = moment(this.examForm.examTime[0]).format(
              "YYYY-MM-DD HH:mm"
            );
            params["limitEndTime"] = moment(this.examForm.examTime[1]).format(
              "YYYY-MM-DD HH:mm"
            );
          }
          if (this.examForm.isLimitNum) {
            params["limitNum"] = this.examForm.limitNum;
          }
          if (this.examForm.isCanRepexam) {
            params["reexamNum"] = this.examForm.reexamNum;
            if (this.examForm.isLimitTime) {
              params["reexamStartTime"] = moment(
                this.examForm.reexamTime[0]
              ).format("YYYY-MM-DD HH:mm");
              params["reexamEndTime"] = moment(
                this.examForm.reexamTime[1]
              ).format("YYYY-MM-DD HH:mm");
            }
          }
          if (this.edit) {
            params["uuid"] = val;
            params["paperId"] = this.examForm.paperId;
            editExamInfo(params).then((res) => {
              if (!res || res.code != 0) return;
              this.$message({
                message: "编辑成功",
                type: "success",
              });
              setItem(this.REFRESH_FLAG, true);
              this.$router.push('/examInfo');
            });
          } else {
            params["paperId"] = this.examForm.paperId;
            saveExamInfo(params).then((res) => {
              if (!res || res.code != 0) return;
              setItem(this.REFRESH_FLAG, true);
              this.successAction(res.data.uuid);
            });
          }
        }
      });
    },
    successAction(examId) {
      const text = "成功创建定向考试，需要继续进行考试学员选择吗？";
      Confirm(text, "成功创建考试", {
        confirmButtonText: "立即选择",
        cancelButtonText: "以后再说",
        type: "warning",
      })
        .then(() => {
          // vue.$emit("selectMember", examId);
          this.examId = examId;
          this.showDirectMemberSelect = {
            flag: true
          }
        })
        .catch(() => {
          this.$router.push('/examInfo');
        });
    },
    addSucceed() {
      this.showDirectMemberSelect = {
        flag: false
      }
      setItem(this.REFRESH_FLAG, true);
      this.$router.push('/examInfo');
    },
    closeClassManage() {
      this.showDirectMemberSelect = {
        flag: false
      }
      this.$router.push('/examInfo');
    }
  },
};
</script>

<style lang="scss" scoped>
$textColor: #51627d;
$textSize: 14px;
.download_text {
  color: #3a85ff;
  // text-decoration: none;
}
.el-select__tags-text {
  font-size: 14px;
}
.avatar-uploader /deep/ .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  background-color: #f7f9fc;
  width: 320px;
  height: 160px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 70px;
  height: 70px;
  line-height: 70px;
  text-align: center;
}

.avatar {
  width: 320px;
  height: 160px;
  display: block;
  object-fit: contain;
}

.upload-text {
  color: $textColor;
  font-size: 13px;
}

.video-output {
  width: 320px;
  height: 160px;
  position: relative;

  .cover-bg {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(1, 1, 1, 0.5);
    z-index: 199;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    color: #ffffff;

    .delete {
      font-size: 20px;
      cursor: pointer;
    }
  }
}

.upload_tip {
  width: 320px;
  text-align: center;
  margin-top: 10px;
}

.upload_tip p {
  font-size: 14px;
  margin: 0;
  line-height: 30px;
  color: #51627d;
}

.upload_tip p.img_tip {
  font-size: 12px;
  color: #96a1b2;
}

.autocomplete {
  width: 100%;
}

.el-autocomplete-suggestion {
  display: none;
}
.form {
  .el-select {
    width: 100%;
  }
  .el-date-editor--datetimerange {
    width: 100%;
  }
  .el-input-number {
    width: 100%;
  }
  .m-l-12 {
    margin-left: 12px;
  }
}
</style>
